import isArray from 'lodash/isArray';
import isNil from 'lodash/isNil';

export const flattenFilters = filters => {
  if (!filters) return [];

  const flattenedFilters = [];

  Object.keys(filters)
    .map(key => {
      const value = !isNil(filters[key]?.value) ? filters[key]?.value : filters[key];
      return {
        id: key,
        values: isArray(value) ? value : [value],
        displayLabel: filters[key]?.displayLabel
      };
    })
    .forEach(({ id, values, displayLabel }) =>
      values.forEach(value => flattenedFilters.push({ id, value, displayLabel }))
    );

  return flattenedFilters.filter(({ value }) => !isNil(value) && value !== '');
};

export const getMinRequiredFilters = () => {
  const envMinRequiredFilters =
    window.GPAC_ENV?.MIN_REQUIRED_FILTERS ?? process.env.REACT_APP_MIN_REQUIRED_FILTERS;
  const minRequiredFilters = Number(envMinRequiredFilters);
  return Number.isFinite(minRequiredFilters) ? minRequiredFilters : 2;
};

export const countEffectiveFilters = (filters = {}) => {
  const uniqueFilterKeys = new Set();

  return Object.entries(filters).reduce((count, [key, filter]) => {
    if (uniqueFilterKeys.has(key)) return count;

    uniqueFilterKeys.add(key);

    if (Array.isArray(filter?.requiredWith)) {
      filter.requiredWith.forEach(dep => uniqueFilterKeys.add(dep));
    }

    return count + 1;
  }, 0);
};
